<script setup>
import { onMounted, computed } from 'vue'
import CharacterEnlarge from '../kijk_live_qmusic_nl_default/text_animations/CharacterEnlarge.vue'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const name = computed(() => props.item.enrichment.newsBulletin?.news_reader?.name)

const timelineTitle = ref(null)

onMounted(async () => {
  gsapTimeline({ name: 'NewsReader' }).add(timelineTitle, frames(25))
})

const { onDisappear } = useDisappearable()
onDisappear(async () => {
  timelineTitle.value?.reverse()
  await gsapTimeline({ name: 'NewsReader - End' }).add(timelineTitle)
})
</script>

<template>
  <div
    :style="{
      left: item.properties.position.xLeft + 'px',
      top: item.properties.position.yTop + 'px',
      fontSize: item.properties.position.fontSize + 'px',
      color: item.properties.position.textColor,
    }"
    class="absolute -tracking-[0.03em] font-cervo text-white font-bold leading-none"
  >
    <CharacterEnlarge :text="name" @timeline="timelineTitle = $event" />
  </div>
</template>
